/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';

import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { manuFactureHead } from '../../../../SharedModules/Table/tableHead';
import {
  setReqInvoiceCalcData,
  getManufacturersByPQR,
  calculateInvoice,
  getMaxQuarterForFreezeDt,
  setErrorMessagesData,
  dispatchManufacturersByPQR,
} from '../Store/actions';
import { getUserDefaults } from '../../../System/UserDefault/store/actions';
import {
  checkQuarterValidation,
  quarterFormatter,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import * as CONSTANTS from '../../../../SharedModules/AppConstants';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import { getRebateProgramDropdownList } from '../../../Research/UnderThresholdInvoices/store/Actions';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';

function RequestInvoiceCalculation() {
  const dispatch = useDispatch();
  const [successMessages, setSuccessMessages] = useState([]);
  const [selected, setSelected] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);

  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const reqInvoiceCalcData = useSelector(
    (state) => state.sharedState.ReqInvoiceCalcReducer?.reqInvoiceCalcData
  );

  const manufacturersByPQR = useSelector(
    (state) => state.sharedState.ReqInvoiceCalcReducer?.manufacturersByPQR
  );

  const calculateInvoiceData = useSelector(
    (state) => state.sharedState.ReqInvoiceCalcReducer?.calculateInvoice
  );
  const defaultQtrRIC = useSelector(
    (state) => state.sharedState.ReqInvoiceCalcReducer?.defaultQtrRIC?.data
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state.sharedState.ReqInvoiceCalcReducer?.errorMessages
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));

  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  const onCellClicked = (e) => {
    setSelected(e.data.mfgId);
  };
  React.useEffect(() => {
    if (reqInvoiceCalcData?.planType) {
      getRebateProgramDropdownList(reqInvoiceCalcData?.planType).then((res) => {
        let list = [];
        if (
          res?.status === constantMessageData.STATUS_MSG &&
          res?.message === constantMessageData.SUCCESS_MSG
        ) {
          if (!_.isEmpty(res.data)) {
            list = _.map(res.data, (val) => ({
              ...val,
              id: val.rebateProgramCd,
              name: `${val.rebateProgramCd} | ${val.shortDescr}`,
            }));
          }
        }
        setRebateProgramList(
          list.sort((key, val) =>
            key.name.toLowerCase().localeCompare(val.name.toLowerCase())
          )
        );
      });
    }
  }, [reqInvoiceCalcData?.planType]);

  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    setSuccessMessages([]);
    if (!(UserDefaultValues && Object.keys(UserDefaultValues)?.length > 0)) {
      getUserDefaultValues(logInUser);
    }
    dispatch(getMaxQuarterForFreezeDt());
    dispatch(
      setReqInvoiceCalcData({
        ...reqInvoiceCalcData,
        quarter:
          reqInvoiceCalcData?.quarter == null
            ? defaultQtrRIC
            : reqInvoiceCalcData?.quarter,
        planType:
          reqInvoiceCalcData?.planType === ''
            ? UserDefaultValues?.planTypeCd
            : reqInvoiceCalcData?.planType,
        rebateProgramCode:
          reqInvoiceCalcData?.rebateProgramCode === ''
            ? UserDefaultValues?.rebateProgramCd
            : reqInvoiceCalcData?.rebateProgramCode,
      })
    );
  }, []);

  // handing highlight tab
  React.useEffect(() => {
    if (errorMessagesFromRedux && errorMessagesFromRedux.length > 0) {
      tabHighLigther('/requestInvoiceCalculation', true);
    } else {
      tabHighLigther('/requestInvoiceCalculation', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  useEffect(() => {
    if (defaultQtrRIC) {
      dispatch(
        setReqInvoiceCalcData({
          ...reqInvoiceCalcData,
          quarter: !reqInvoiceCalcData?.quarter
            ? defaultQtrRIC
            : reqInvoiceCalcData?.quarter,
          planType:
            reqInvoiceCalcData?.planType === ''
              ? UserDefaultValues?.planTypeCd
              : reqInvoiceCalcData?.planType,
          rebateProgramCode:
            reqInvoiceCalcData?.rebateProgramCode === ''
              ? UserDefaultValues?.rebateProgramCd
              : reqInvoiceCalcData?.rebateProgramCode,
        })
      );
    }
  }, [defaultQtrRIC]);

  useEffect(() => {
    if (!calculateInvoiceData) {
      return;
    }

    const isSuccess = String(calculateInvoiceData?.status) === '001';
    const runProcedure = calculateInvoiceData?.runProcedure;

    if (isSuccess) {
      if (runProcedure === 'N') {
        setSuccessMessages([
          constantMessageData.INVOICE_CALCULATION_PROCEDURE_MSG,
        ]);
      } else if (runProcedure === 'L') {
        setSuccessMessages([CONSTANTS.INVOICE_JOB_DEFERED]);
      }
      dispatch(setErrorMessagesData([]));
      return;
    }

    if (calculateInvoiceData?.error === 'API failed') {
      dispatch(
        setErrorMessagesData([
          {
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message: CONSTANTS.ERR_PROCESSING_REQ,
          },
        ])
      );
      setSuccessMessages([]);
      return;
    }

    const businessErrorStatus =
      calculateInvoiceData?.error?.status ?? calculateInvoiceData?.status;
    if (String(businessErrorStatus) === '002') {
      dispatch(
        setErrorMessagesData([
          {
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message:
              calculateInvoiceData?.error?.message ||
              calculateInvoiceData?.message ||
              CONSTANTS.ERR_PROCESSING_REQ,
          },
        ])
      );
      setSuccessMessages([]);
      return;
    }

    if (calculateInvoiceData?.status || calculateInvoiceData?.error) {
      dispatch(
        setErrorMessagesData([
          {
            field: 'resultNotFound',
            errorType: 'resultNotFound',
            message: CONSTANTS.ERR_PROCESSING_REQ,
          },
        ])
      );
      setSuccessMessages([]);
    }
  }, [calculateInvoiceData, dispatch]);

  const handleReqInvoiceCalcData = (e) => {
    setSuccessMessages([]);
    if (e.target.name === 'allManufacturers') {
      if (e.target.checked) {
        setSelected(null);
      }
      dispatch(
        setReqInvoiceCalcData({
          ...reqInvoiceCalcData,
          [e.target.name]: e.target.checked ? 'Yes' : 'No',
        })
      );
    } else {
      dispatch(
        setReqInvoiceCalcData({
          ...reqInvoiceCalcData,
          [e.target.name]: e.target.value,
          ...('planType' in reqInvoiceCalcData &&
            e.target.name === 'planType' && { rebateProgramCode: '-1' }),
        })
      );
    }
  };

  const validateInvoiceCalcReq = () => {
    setSuccessMessages([]);
    let localErr = [];
    if (
      reqInvoiceCalcData.rebateProgramCode === '' ||
      reqInvoiceCalcData.rebateProgramCode === '-1' ||
      reqInvoiceCalcData.rebateProgramCode === undefined
    ) {
      localErr = localErr?.filter((item) => item.filed !== 'resultNotFound2');
      localErr.push({
        field: 'rebateProgramCode',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    }
    if (reqInvoiceCalcData?.quarter === '') {
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    } else if (!checkQuarterValidation(reqInvoiceCalcData?.quarter)) {
      localErr = localErr.filter(
        (item) => item.field !== 'quarter' && item.filed !== 'resultNotFound2'
      );
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
      });
    }
    dispatch(setErrorMessagesData([...new Set(localErr)]));
    return !localErr.length > 0;
  };

  const searchManufacturers = () => {
    if (validateInvoiceCalcReq()) {
      setSuccessMessages([]);
      dispatch(setErrorMessagesData([]));
      setSelected(null);
      dispatch(getManufacturersByPQR(reqInvoiceCalcData));
    }
  };

  const runInvoiceCalculation = (e, runFlag) => {
    setSuccessMessages([]);
    dispatch(setErrorMessagesData([]));
    if (validateInvoiceCalcReq()) {
      const reqInvoiceCalcDataPayload = {
        ...reqInvoiceCalcData,
        runProcedure: runFlag,
        userId: logInUser,
        manufacturerId:
          reqInvoiceCalcData.allManufacturers === 'No' && selected != null
            ? selected
            : null,
      };
      dispatch(calculateInvoice(reqInvoiceCalcDataPayload));
    }
  };

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0].procedureId;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({ PROCEDURE_ID: selectedRow });
    }
  };
  // hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesFromRedux || [];
    if (type === 'rebateProgramCode') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCode' &&
            item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'rebateProgramCode',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCode' &&
            item.field !== 'resultNotFound'
        );
      }
    }

    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );

          dispatch(
            setReqInvoiceCalcData({
              ...reqInvoiceCalcData,
              quarter: autoFormateDate(value?.toUpperCase()),
            })
          );
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }
    dispatch(setErrorMessagesData([...new Set(localErr)]));
  };
  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  useEffect(() => {
    if (!gridApi || manufacturersByPQR?.data === 0) return;
    const selectedRows = gridApi.getSelectedRows();
    if (selectedRows.length > 0) return;
    const firstNode = gridApi.getDisplayedRowAtIndex(0);
    if (firstNode) {
      firstNode.setSelected(true);
     // onSelectionChanged({ api: gridApi }); 
    }
  }, [gridApi, manufacturersByPQR?.data]);
  return ( 
    <div className="tBillPanel custom-check">
      <div className="panel tBillPanel-space devider-line pb-0">
        <Spinner load={spinnerLoader} />
        <CustomSeparator
          parent1="Invoice"
          parent2="Calculate Invoice Details"
        />
        {!fullScreenView && (
          <>
            {!errorMessagesFromRedux?.length > 0 && (
              <DisplaySuccessMessages successMessages={successMessages} />
            )}
            <DisplayErrorMessages
              errorMessages={[
                ...new Set(
                  errorMessagesFromRedux?.length > 0
                    ? _.map(errorMessagesFromRedux, (l) => l.message)
                    : []
                ),
              ]}
            />
            <fieldset className="custom-fieldset">
              <div className="panel mb-3">
                <div className="row">
                  <div className="col-sm-12">
                    <fieldset className="custom-fieldset">
                      <legend
                        className="same-font-family"
                        id="demo-row-radio-buttons-group-label"
                      >
                        Plan Type<span className="mandatory"> *</span>{' '}
                      </legend>
                      <div className="form-wrapper p-0 mt-2">
                        <div className="mui-custom-form input-md field-xl">
                          <div className="sub-radio no-margin">
                            <FormControl>
                              <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="planType"
                                onChange={handleReqInvoiceCalcData}
                                value={reqInvoiceCalcData?.planType}
                                required
                              >
                                <FormControlLabel
                                  style={{ marginRight: '10px' }}
                                  value="FD"
                                  control={<Radio />}
                                  label="Medicaid"
                                  data-test="Medicaid"
                                />
                                <FormControlLabel
                                  style={{ marginRight: '10px' }}
                                  value="COMM"
                                  control={<Radio />}
                                  label="Commercial"
                                  data-test="Commercial"
                                />
                                <FormControlLabel
                                  style={{ marginRight: '10px' }}
                                  value="ST"
                                  control={<Radio />}
                                  label="State"
                                  data-test="State"
                                />
                                <FormControlLabel
                                  style={{ marginLeft: '10px' }}
                                  value="SUPP"
                                  control={<Radio />}
                                  label="Supplemental"
                                  data-test="Supplemental"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4">
                    <div className="mui-custom-form with-select input-md override-width-95">
                      <TextField
                        label="Rebate Program"
                        fullWidth
                        select
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          id: 'rebateProgramCode',
                        }}
                        required
                        onChange={handleReqInvoiceCalcData}
                        id="rebateProgramCode"
                        name="rebateProgramCode"
                        value={reqInvoiceCalcData?.rebateProgramCode}
                        onBlur={(e) =>
                          handleOnblurEvent('rebateProgramCode', e.target.value)
                        }
                        className={
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'rebateProgramCode'
                                  ? 'mandate-fields'
                                  : null
                              )
                            : null
                        }
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'rebateProgramCode'
                                  ? l.message
                                  : null
                              )
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'rebateProgramCode'
                                  ? l.message
                                  : null
                              )
                            : null
                        }
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        {rebateProgramList && rebateProgramList?.length > 0
                          ? rebateProgramList.map((item) => {
                              return (
                                <MenuItem
                                  key={item.rebateProgramCd}
                                  value={item.rebateProgramCd}
                                >
                                  {item.rebateProgramCd} {'|'} {item.shortDescr}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="mui-custom-form input-md override-width-95">
                      <TextField
                        label="Quarter"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                        inputProps={{
                          maxLength: 6,
                          id: 'quarter',
                        }}
                        id="quarter"
                        name="quarter"
                        value={reqInvoiceCalcData?.quarter}
                        onChange={handleReqInvoiceCalcData}
                        onBlur={(e) =>
                          handleOnblurEvent('quarter', e.target?.value)
                        }
                        className={
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'quarter' ? 'mandate-fields' : null
                              )
                            : null
                        }
                        helperText={[
                          ...new Set(
                            errorMessagesFromRedux?.length > 0
                              ? _.map(errorMessagesFromRedux, (l) =>
                                  l.field === 'quarter' ? l.message : null
                                )
                              : null
                          ),
                        ]}
                        error={[
                          ...new Set(
                            errorMessagesFromRedux?.length > 0
                              ? _.map(errorMessagesFromRedux, (l) =>
                                  l.field === 'quarter' ? l.message : null
                                )
                              : null
                          ),
                        ]}
                      />
                    </div>
                  </div>
                  <div className="col-sm-4">
                    <div className="mui-custom-form with-select input-md mui-custom-form-with-margin2 ">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              name="allManufacturers"
                              checked={
                                reqInvoiceCalcData?.allManufacturers === 'Yes'
                              }
                               onChange={(e) => {
                                handleReqInvoiceCalcData(e);
                                   if (!e.target.checked) {
                                    searchManufacturers();
                                  }
                              }}
                            />
                          }
                          label="All Manufacturers"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="float-right mt-2 hide-on-print">
                  {!(reqInvoiceCalcData?.allManufacturers === 'Yes') ? (
                    <Button
                      className="btn-success same-font-family"
                      onClick={searchManufacturers}
                    >
                      <SVGComponent iconName="Icon-search" /> Search
                    </Button>
                  ) : null}
                  <Button
                    className="btn-success same-font-family"
                    onClick={(e) => {
                      runInvoiceCalculation(e, 'N');
                    }}
                    disabled={
                      reqInvoiceCalcData.allManufacturers === 'No' &&
                      selected == null
                    }
                  >
                    <SVGComponent iconName="Icon-run-now" /> Run Now
                  </Button>
                  <Button
                    className="btn-success same-font-family"
                    onClick={(e) => runInvoiceCalculation(e, 'L')}
                    disabled={
                      reqInvoiceCalcData.allManufacturers === 'No' &&
                      selected == null
                    }
                  >
                    <SVGComponent iconName="Icon-run-later" /> Run Later
                  </Button>
                </div>
              </div>
            </fieldset>
          </>
        )}
        <div className="clearfix" />
      </div>

      {reqInvoiceCalcData?.allManufacturers !== 'Yes' ? (
        <div className="panel tBillPanel-space pb-0">
          <div className="FRR-custom-table tbl-manufacturer-home">
            <Grid
              gridHeight={fullScreenView ? '100vh' : 350}
              rowData={manufacturersByPQR?.data || []}
              columnDefs={manuFactureHead}
              gridCall={onGridReady}
              data-testid="onEditingStopped"
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              singleClickEdit={false}
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              exportFile
              onSelect={onCellClicked}
              fileName="Request Invoice Calculation"
              handleViewHistory={handleViewHistory}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
export default withRouter(RequestInvoiceCalculation);
